import { MessageCircle } from "lucide-react";

const PHONE = "917338745559"; // country + number, no + or spaces
const MESSAGE = encodeURIComponent(
  "Hi Celesta! I'd like to make an enquiry about a trip."
);

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${MESSAGE}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat with Celesta on WhatsApp"
      className="group fixed z-40 bottom-6 right-6 sm:bottom-8 sm:right-8 flex items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] text-white font-semibold uppercase tracking-[0.16em] text-xs shadow-[0_12px_35px_-8px_rgba(37,211,102,0.6)] hover:bg-[#1ebe57] transition-all duration-300 hover:scale-105"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-75 group-hover:animate-ping" />
        <MessageCircle size={20} strokeWidth={2.25} className="relative" />
      </span>
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
